import { render, staticRenderFns } from "./Trading.vue?vue&type=template&id=3fc76560&scoped=true"
import script from "./Trading.vue?vue&type=script&lang=js"
export * from "./Trading.vue?vue&type=script&lang=js"
import style0 from "./Trading.vue?vue&type=style&index=0&id=3fc76560&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc76560",
  null
  
)

export default component.exports